var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7014 7.79442L13.4481 9H14.68H21C21.2652 9 21.5196 9.10536 21.7071 9.29289C21.8946 9.48043 22 9.73479 22 10V12C22 12.1217 21.9784 12.2348 21.9336 12.353L18.9208 19.3862L18.9207 19.3862L18.9169 19.3954C18.7688 19.7508 18.4177 20 18 20H9C8.73478 20 8.48043 19.8946 8.29289 19.7071C8.10536 19.5196 8 19.2652 8 19V9C8 8.72455 8.10794 8.47628 8.29711 8.28711L14.1733 2.41087L14.5229 2.75711C14.5233 2.7575 14.5237 2.7579 14.5241 2.75829C14.6141 2.84893 14.67 2.97722 14.67 3.11C14.67 3.16039 14.6654 3.20275 14.66 3.23068L13.7014 7.79442ZM4 10V20H2V10H4Z",
    stroke: "#93929C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.77033d606c5c03d33372899ee1b20e99.svg";
export { ForwardRef as ReactComponent };